define.alias("shared/utils/formatters/ig-user-from-basic-display", "preview-grid/utils/formatters/ig-user-from-basic-display");